import { Controller, useForm } from 'react-hook-form';
import React from 'react'
import { Button, MenuItem } from '@mui/material';
import { Select } from '@mui/material';
import { useGetChannelConnections } from 'hooks/useGetChannelConnections';
import { useDispatch } from 'react-redux';
import { updateChatSettingsAction } from 'redux/reducers/appLayout';

interface ChatSettingsFormProps {
    chatSettings: any;
    onClose: () => void;
}
export const ChatSettingsForm = ({ chatSettings, onClose }: ChatSettingsFormProps) => {
    const dispatch = useDispatch();

    // Form
    const { handleSubmit, control, watch, formState: { errors } } = useForm({
        defaultValues: {
            source: chatSettings?.source || "INSTAGRAM",
            externalAccountUserName: chatSettings?.externalAccountUserName || "",
        },
        mode: "onChange",
    });

    const { data: channelConnections } = useGetChannelConnections();
    console.log("channelConnections: ", channelConnections)

    // On submit
    const onSubmit = (formData: any) => {
        console.log("formData: ", formData);
        dispatch(updateChatSettingsAction({
            orgID: localStorage.getItem("orgID") as string,
            source: formData.source,
            externalAccountUserName: formData.externalAccountUserName,
        }));
        onClose();
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
            {/* Channel types as select  */}
            <Controller control={control} name="source" render={({ field }) => (
                <Select {...field} fullWidth>
                    <MenuItem value="WHATSAPP">WhatsApp</MenuItem>
                    <MenuItem value="TELEGRAM">Telegram</MenuItem>
                    <MenuItem value="INSTAGRAM">Instagram</MenuItem>
                </Select>
            )} />

            {/* User accounts */}
            <Controller control={control} name="externalAccountUserName" render={({ field }) => (
                <Select {...field} fullWidth>
                    {channelConnections?.length > 0 &&
                        channelConnections?.filter((channelConnection: any) => channelConnection.source === watch("source"))
                            ?.map((channelConnection: any) => (
                                <MenuItem key={channelConnection.id} value={channelConnection.externalAccountUserName}>
                                    {channelConnection.externalAccountUserName}
                                </MenuItem>
                            ))}
                </Select>
            )} />

            {/* Save button */}
            <Button variant="contained" color="primary" fullWidth type="submit">Применить</Button>
        </form>

    )
}
